module.exports = __webpack_public_path__ + "e3ce7799.png";